// @flow
import { Base, Fqdn, Text } from '@gandi/ui';

import type { AvailabilityIconName } from './Icon/IconContainer';

import { ProvidedPlaceholderRow } from './Placeholder/ProvidedPlaceholderRow';
import { ProvidedContainerLayout } from './ProvidedContainerLayout';

import styles from './UnavailableRowContainer.scss';

type Props = {
  children: React.Node,
  availabilityIconName?: AvailabilityIconName,
  availabilityText: string | React.Node,
  fqdn: string,
};

export function UnavailableRowContainer({
  availabilityIconName,
  availabilityText,
  fqdn,
  children,
}: Props): React.MixedElement {
  if (!availabilityText || !availabilityIconName) {
    return <ProvidedPlaceholderRow fqdn={fqdn} />;
  }

  return (
    <ProvidedContainerLayout
      availabilityIconName={availabilityIconName || 'unavailable'}
      renderButton={<div className={styles.buttonBlock}>{children}</div>}
    >
      {typeof availabilityText === 'string' ? (
        <Text className={styles.info}>{availabilityText}</Text>
      ) : (
        <div className={styles.info}>{availabilityText}</div>
      )}
      <Base
        flex
        size="bigger"
        weight="semibold"
        flexAlignItemsCenter
        flexWrap
        className={styles.fqdnBlock}
      >
        <Fqdn maxLength={42} color="weak">
          {fqdn}
        </Fqdn>
      </Base>
    </ProvidedContainerLayout>
  );
}

export function UnavailableErrorContainer({
  className,
  info,
  fqdn,
}: {
  className?: string,
  fqdn: string,
  info: string,
}): React.MixedElement {
  return (
    <ProvidedContainerLayout availabilityIconName="fail" className={className}>
      <Text className={styles.info}>{info}</Text>
      <Base
        weight="semibold"
        flex
        columnGap="xsmall"
        flexAlignItemsBaseline
        className={styles.fqdnBlock}
      >
        {/* No Fqdn component in the ErrorBoundary:
              don't try to decode punycode again if it was the reason we are here.
            */}
        {fqdn}
      </Base>
    </ProvidedContainerLayout>
  );
}
